module.exports = __webpack_public_path__ + "static/media/360-black-18dp.dc3bb0e6.svg";